import localFont from "next/font/local";

export const inter = localFont({
  src: [
    {
      path: "./inter-v20-latin-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./inter-v20-latin-600.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./inter-v20-latin-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  display: "swap",
  variable: "--font-inter",
  fallback: ["Arial", "sans-serif"],
  adjustFontFallback: "Arial",
});

export const arimo = localFont({
  src: [
    {
      path: "./arimo-v36-latin-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  display: "swap",
  variable: "--font-arimo",
  fallback: ["Arial", "sans-serif"],
  adjustFontFallback: "Arial",
});

export const fonts = {
  inter,
  arimo,
};
